export default function ResetIcon() {
  return (
    <svg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M3.33398 3.3336V7.50027H3.81898M3.81898 7.50027C4.37219 6.13204 5.36372 4.98602 6.63818 4.24182C7.91263 3.49761 9.39799 3.19728 10.8615 3.38788C12.3249 3.57849 13.6838 4.24926 14.7251 5.29508C15.7664 6.3409 16.4314 7.70265 16.6157 9.16693M3.81898 7.50027H7.50065M16.6673 16.6669V12.5003H16.1832M16.1832 12.5003C15.6291 13.8677 14.6373 15.0128 13.363 15.7563C12.0887 16.4999 10.6038 16.7999 9.14073 16.6093C7.6777 16.4188 6.31915 15.7485 5.27776 14.7034C4.23638 13.6582 3.57095 12.2973 3.38565 10.8336M16.1832 12.5003H12.5007'
        stroke='currentColor'
        strokeWidth='1.3'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}
